import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../services/translate.service';

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {
  translate: any
  constructor(private tn: TranslateService) {
    this.translate = localStorage.getItem('translate')
    if (!this.translate) localStorage.setItem('translate', 'EN')

  }

  transform(value: string) {
    if (this.tn.translateItems.length == 0) return value;
    let Language = this.tn.translateItems?.Language_items.find((fn: any) => fn.Language_name == this.translate)
    if (!Language) return value;
    let text = Language.Language_items.find((lg: any) => lg.Translate_name == value)
    if (!text) return value;
    return text.Translate_value;
  }

}
